import { useEffect } from "react";
import { auth, db } from "../firebase";
import {
  collection,
  doc,
  getDoc,
  query,
  orderBy,
  onSnapshot,
  getDocs,
  addDoc,
  where,
  serverTimestamp,
  limit,
} from "firebase/firestore";

export const useListenForNewMessages = () => {
  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      console.error("No user is currently authenticated");
      return;
    }

    let unsubscribeConversations;

    const setupListeners = async () => {
      try {
        const conversationsQuery = query(
          collection(db, "conversations"),
          where("participants", "array-contains", user.uid)
        );

        unsubscribeConversations = onSnapshot(
          conversationsQuery,
          (snapshot) => {
            snapshot.docChanges().forEach(async (change) => {
              if (change.type === "modified") {
                const conversationData = change.doc.data();
                console.log("Conversation data:", conversationData);

                const otherUserId = conversationData.participants.find(
                  (id) => id !== user.uid
                );

                const newUnreadCount =
                  conversationData.unreadCount?.[user.uid] || 0;
                console.log("New unread count:", newUnreadCount);

                if (newUnreadCount > 0) {
                  const messagesRef = collection(
                    db,
                    `conversations/${change.doc.id}/messages`
                  );
                  const lastMessageQuery = query(
                    messagesRef,
                    orderBy("timestamp", "desc"),
                    limit(1)
                  );
                  const lastMessageSnapshot = await getDocs(lastMessageQuery);
                  
                  if (!lastMessageSnapshot.empty) {
                    const lastMessageDoc = lastMessageSnapshot.docs[0];
                    const lastMessage = {
                      id: lastMessageDoc.id,
                      ...lastMessageDoc.data()
                    };
                    console.log("Last message:", lastMessage);

                    if (lastMessage && lastMessage.id) {
                      const notificationQuery = query(
                        collection(db, "notifications"),
                        where("userId", "==", user.uid),
                        where("postId", "==", lastMessage.id),
                        where("type", "==", "message")
                      );
                      const querySnapshot = await getDocs(notificationQuery);
                      if (querySnapshot.empty) {
                        try {
                          // Get the sender's name
                          const senderDoc = await getDoc(doc(db, "users", otherUserId));
                          const senderName = senderDoc.data()?.displayName || "Alguien";

                          await addDoc(collection(db, "notifications"), {
                            userId: user.uid,
                            companyId: otherUserId,
                            postId: lastMessage.id,
                            message: `${senderName} te ha enviado un nuevo mensaje`,
                            type: "message",
                            read: false,
                            timestamp: serverTimestamp(),
                          });
                          console.log("Message notification added successfully");
                        } catch (error) {
                          console.error("Error adding message notification: ", error);
                        }
                      } else {
                        console.log("Message notification already exists for this message");
                      }
                    } else {
                      console.log("Last message found but has no id");
                    }
                  } else {
                    console.log("No messages found in the conversation");
                  }
                }
              }
            });
          }
        );
      } catch (error) {
        console.error("Error setting up listeners: ", error);
      }
    };

    setupListeners();

    return () => {
      if (unsubscribeConversations) unsubscribeConversations();
    };
  }, []);
};